<mbs-alert *ngIf="noEnabledAlerts"
           type="warning"
           [icon]="true">
  <div class="font-weight-bold">
    {{ 'mbs-ui:rmm-custom-alerting.alertNotEnabledErrorTitle' | i18next }}
  </div>
  <div>
    {{ 'mbs-ui:rmm-custom-alerting.alertNotEnabledErrorDesc' | i18next }}
  </div>
</mbs-alert>

<mbs-rmm-custom-alert-full [showInOneRow]="true"
                           [usingSwitch]="false"
                           [disableChangeDetector]="true"
                           (dataChange)="dataChange($event)">
</mbs-rmm-custom-alert-full>
